import { render, staticRenderFns } from "./EvictionTable.vue?vue&type=template&id=e5d93e4e&scoped=true&"
import script from "./EvictionTable.vue?vue&type=script&lang=js&"
export * from "./EvictionTable.vue?vue&type=script&lang=js&"
import style0 from "./EvictionTable.vue?vue&type=style&index=0&id=e5d93e4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d93e4e",
  null
  
)

export default component.exports